<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { CURRENCY_TOWN_DATA_INDEX } from '../tools'
const [name] = createNamespace('CurrencyTownResettleStandardDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <>
        <div class='ant-row-form-item mb-12'>
          在县城规划区范围内购房包干费用=包干货币化安置费用
          <b>{props.data[CURRENCY_TOWN_DATA_INDEX.CU_COMP]} 元/人</b>+ 包干奖励补助
          <b>{props.data[CURRENCY_TOWN_DATA_INDEX.CU_BONUS]} 元/人</b>
          （含拆迁奖励及过渡费）
        </div>
        <div class='ant-row-form-item'>
          在乡镇购房包干费用=包干货币化安置费用
          <b>{props.data[CURRENCY_TOWN_DATA_INDEX.RT_COMP]} 元/人</b>+ 包干奖励补助
          <b>{props.data[CURRENCY_TOWN_DATA_INDEX.RT_BONUS]} 元/人</b>
          （含拆迁奖励及过渡费）
        </div>
      </>
    )
  }
})
</script>
